export default function compareLinePositions(a, b) {
  if (!a?.position) return 0;
  const aPos = Number.parseInt(a.position);
  const bPos = Number.parseInt(b.position);

  if (aPos < bPos) return -1;
  if (aPos > bPos) return 1;
  return 0;
}